import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';

class Heading extends PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        className: PropTypes.string,
        level: PropTypes.oneOf([1, 2, 3, 4, 5, 6])
    };

    static defaultProps = {
        level: 3
    };

    render() {
        const {children, className, level} = this.props;

        const HeadingTag = `h${level}`;

        return <HeadingTag className={className}>{children}</HeadingTag>;
    }
}

export default Heading;
